import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OperatorStatus} from "~/chat/ts/data/OperatorStatus";

export default class OperatorStatusChangedInAnotherApp extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "operatorStatusChangedInAnotherApp";
    }

    public receive(payload: CometOperatorApplication.OperatorStatusChangedInAnotherAppCometMessageOpenApiModel): void {
        OperatorStatusChangedInAnotherApp.updateStatusId(
            payload.statusId as OperatorStatus, payload.customStatusId
        );
    }

    public static updateStatusId(statusId: OperatorStatus, customStatusId: string) {
        OperatorAccountStore.setStatusId({
            statusId,
            customStatusId
        });
    }

}